import { combineReducers } from 'redux';
import filterResults from './filterResults';
import filterValues from './filterValues';
const searchAndFiltering = combineReducers({
  filterResults,
  filterValues
});
export default searchAndFiltering;